<template>
  <v-card
      flat
      max-width="500"
      mim-width="350"
      class="mx-auto">
    <v-card class="mt-2" rounded="0" flat>
      <v-card class="pa-2">
        <v-toolbar
            density="compact" color="white">
          <v-spacer></v-spacer>
          <v-btn icon @click="goToTicket">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div id="qr-code-img" class="bg-white">
          <v-card-title class="pt-0 font-weight-bold text-h6 text-center">
            {{ticketInfo.tk_name}}
          </v-card-title>

          <v-row>
            <v-col cols="12" class="pb-0">
              <v-img class="mx-auto ma-4 mb-0" justify="center" width="150">
                <qrcode-vue id="qr-code" v-if="ticketInfo.tktno" :value="ticketInfo.tktno" :size="150" level="H"></qrcode-vue>
              </v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-card-text v-if="ticketInfo.refresh_sec > 0" class="pa-0 mb-2 text-body-2 text-center">
                ({{timerStr}})
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 font-weight-bold text-body-1 text-center">
                {{ ticketInfo.msg1 }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 text-body-1 text-center">
                ({{ ticketInfo.tktorgno }})
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 font-weight-bold text-body-1 text-center">
                쿠폰번호: {{ ticketInfo.tktno }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="ticketInfo.msg2" cols="12" class="pa-0">
              <v-card-text class="pa-3 pb-0  text-body-2 text-center">
                {{ ticketInfo.msg2 }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="ticketInfo.msg3" cols="12" class="pa-0">
              <v-card-text class="pa-3 pt-1 pb-0 text-body-2 text-center">
                {{ ticketInfo.msg3 }}
              </v-card-text>
            </v-col>
          </v-row>
        </div>

        <v-row class="pa-0 pt-6 ma-0">
          <v-col cols="12" class="pa-0">
            <v-card-actions class="justify-center mb-4">
              <v-btn v-if="ticketInfo.pin_yn === 'Y'" color="primary" variant="tonal" @click="dialog2 = true">사용완료처리</v-btn>
              <v-btn color="primary" variant="tonal" :disabled="!ticketInfo.tktno" @click="downloadQr(ticketInfo.tk_name)">다운로드</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>

        <v-dialog
            max-width="500"
            v-model="dialog2">
          <v-card class="pa-3">
            <v-row class="pa-0" justify="end">
              <v-btn
                  class="pt-3 pr-3"
                  icon
                  @click="closeDialog()"
                  density="comfortable"
                  variant="plain">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
            <v-card-title class="pt-0 pb-0 font-weight-bold text-h6 text-center">
              {{ticketInfo.tk_name}}
            </v-card-title>
            <v-card-text class="pt-2 font-weight-bold text-body-1 text-center">
              쿠폰번호: {{ ticketInfo.tktno }}
            </v-card-text>
            <v-text-field
                v-model="usePincode"
                density="compact"
                variant="outlined"
                type="number"
                inputmode="numeric" class="input-number-password"
                min="5"
                max="20"
                single-line
                hide-details>
            </v-text-field>
            <v-card-actions class="justify-center mt-2 mb-4">
              <v-btn color="primary" variant="tonal" @click="useTicket()">사용완료</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-card>
  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import {ticket} from "@/api";
import commonStore from "@/store/common";
import MobileFooter from "@/components/common/MobileFooter";
import QrcodeVue from "qrcode.vue";
import authStore from "@/store/auth";
import domtoimage from "dom-to-image-more";
import dayjs from "dayjs";

export default {
  name: "TicketDetail",
  components: {MobileFooter, QrcodeVue},
  data() {
    return {
      dialog2: false,
      ticketInfo: {},
      timer: null,
      timerStr: '',
      interval: null,
      usePincode: '',
      isFocused: false,
      isAuth: false,
    }
  },
  async created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.getHavingTicket()
    this.validationCheck()
  },
  methods: {
    validationCheck() {
      if (authStore.state.authInfo.token === null) {
        alert("잘못된 접근입니다.")
        this.$router.push('/')
        return
      }
    },
    timerStart: function(totalSeconds) {
      if (totalSeconds  == null || totalSeconds  <= 0) {
        return;
      }
      if(this.interval != null) {
        clearInterval(this.interval)
      }

      this.timeCounter = totalSeconds
      this.timerStr = this.prettyTime(totalSeconds)

      // 1초에 한번씩 start 호출
      this.interval = setInterval(() => {
        if(!this.dialog2) {
          this.timeCounter--; //1초씩 감소
          this.timerStr = this.prettyTime(this.timeCounter);
          if (this.timeCounter <= 0) {
            this.timerClear()
            this.getHavingTicket()
          }
        }
      }, 1000);

      return this.interval
    },
    timerClear: function () {
      if (this.interval != null) {
        clearInterval(this.interval)
      }
      if(this.timer != null){
        this.timeCounter = 0;
        this.timer = null;
      }
      this.timerStr = "00:00";
    },
    prettyTime: function(timeCounter) {
      // 시간 형식으로 변환 리턴
      let t = timeCounter / 60;
      let minutes = parseInt(t);
      let secondes = Math.round((t - minutes) * 60);
      return (
          minutes.toString().padStart(2, "0") +
          ":" +
          secondes.toString().padStart(2, "0")
      );
    },
    goToTicket() {
      this.$router.push('/ticket')
    },
    getHavingTicket() {
      // 인증정보, 티켓번호, 사용처리 팝업 오픈여부 검증
      if (!this.$route.params.tktorgno) {
        alert("유효하지 않은 티켓 정보 입니다.")
        this.$router.push('/ticket')
        return
      }

      this.timerClear()
      ticket.getHavingTicket(
          commonStore.state.common.corp,
          commonStore.state.common.brch,
          this.$route.params.tktorgno
      )
          .then(data => {
            console.log(data)
            this.ticketInfo = data.data

            if (!this.ticketInfo.tktorgno || this.ticketInfo.used_yn !== 'N') {
              alert("유효하지 않은 티켓 정보 입니다.")
              this.$router.push('/ticket')
              return
            }

            if(this.ticketInfo.refresh_yn === 'Y') {
              this.timerStart(this.ticketInfo.refresh_sec)
            } else {
              this.timerStr = '00:00'
            }

          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    closeDialog() {
      this.usePincode = ''
      this.dialog2 = false
    },
    useTicket() {
      if (!this.isAuth) {
        return
      }

      ticket.useTicket(
          commonStore.state.common.corp,
          commonStore.state.common.brch,
          this.ticketInfo.tktype,
          this.ticketInfo.tktno,
          this.ticketInfo.tktorgno,
          this.ticketInfo.validto,
          this.ticketInfo.tk_name,
          this.usePincode
      )
          .then(data => {
            console.log(data)
            alert("사용처리되었습니다.")
            this.$router.push('/ticket')
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              if (err.result.error_message) {
                alert(err.result.error_message)
              } else {
                alert(err)
              }
            }
          })
    },
    downloadQr(name) {
      const node = document.getElementById('qr-code-img');
      domtoimage.toJpeg(node, { quality: 0.95 })
          .then(function (dataUrl) {
            const link = document.createElement('a');
            link.download = name + '_' + dayjs().format('YYYYMMDD') + '.jpg';
            link.href = dataUrl;
            link.click();
          });
    },
  }
}
</script>

<style scoped>
.input-number-password {
  -webkit-text-security: disc;
}
</style>